import React from "react";

const APPS = [
  {
    key: "orderart-pos-android",
    name: "OrderArt POS",
    platform: "Android",
    description:
      "The countertop/tablet ordering app — dual-screen cart, floor plan, and payments.",
    icon: "/images/orderart-pos-app-icon.png",
    downloadUrl: "/downloads/orderart-pos.apk",
    fileName: "orderart-pos.apk",
  },
];

/**
 * Apps a restaurant device needs installed alongside the web POS. Android-only for now —
 * downloads the APK directly since it isn't on the Play Store; the device installing it
 * must have "Install unknown apps" allowed for the browser doing the download.
 */
const AppsPanel = () => {
  return (
    <div className="d-flex flex-column gap-3">
      {APPS.map((app) => (
        <div key={app.key} className="cardStyle p-3 appCard">
          <img src={app.icon} alt={`${app.name} icon`} className="appCardIcon" />

          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2">
              <strong>{app.name}</strong>
              <span className="appPlatformBadge">{app.platform}</span>
            </div>
            <div style={{ fontSize: "13px", opacity: 0.75, marginTop: "2px" }}>
              {app.description}
            </div>
          </div>

          <a
            href={app.downloadUrl}
            download={app.fileName}
            className="btn iconBtn btnPrimary appDownloadBtn"
          >
            Download &amp; Install
          </a>
        </div>
      ))}

      <div className="cardStyle p-3" style={{ fontSize: "13px", opacity: 0.75 }}>
        Open this page on the Android device you want to install it on, then tap
        "Download &amp; Install". Since this isn't from the Play Store, Android may ask you
        to allow "Install unknown apps" for the browser the first time — allow it, then open
        the downloaded file to install. iOS isn't available yet.
      </div>
    </div>
  );
};

export default AppsPanel;
